import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BusinessExpansionState {
    isFormFilled: boolean | null;
    isChamberMember: boolean | null;
    formId?: number;
    // Contact Step Fields
    haveYouFill?: string;
    member?: string;
    companyName: string;
    dcMembershipNumber: string;
    tradeLicenseNumber: string;
    attachtradeLicenseDoc?: any;
    attachMembershipDoc?: any;
    contactName: string;
    jobTitle: string;
    phoneNumber: string;
    companyOwnerName: string;
    companyOwnerDesignation: string;
    companyOwnerEmail: string;
    website: string;
    attachCompanyProfile?: any;
    companyPhysicalAddress: string;
    // Business Step Fields
    numberOfEmployees: string;
    isYourCompanyHeadquarteredInDubai: string;
    numberOfYearsOperatingInDubai: string;
    annualRevenue: string;
    productAndServices: string;
    businessPurpose?: any; // Multi-select usually array or string
    pleaseSpecifyOthersCompanyIsInterested: string;
    areYourProductsManufacturedInDubai: string;
    additionalInformation: string;
    currentInternationalMarketsCompany?: any; // Multi-select
    doYouHaveAnyPreviousExperience: string;
    descriptionOfHowYourCompanyPlansToExpand: string;
    previousFromCountryData?: any[];
    businessExpandCountryData?: any[];
    inquiryVersion: number;
    otherBusinessSector: string;
}

const initialState: BusinessExpansionState = {
    isFormFilled: null,
    isChamberMember: null,
    // Initialize common fields
    formId: 0,
    dcMembershipNumber: '',
    companyName: '',
    tradeLicenseNumber: '',
    contactName: '',
    jobTitle: '',
    phoneNumber: '',
    companyOwnerName: '',
    companyOwnerDesignation: '',
    companyOwnerEmail: '',
    website: '',
    companyPhysicalAddress: '',
    numberOfEmployees: '',
    isYourCompanyHeadquarteredInDubai: '',
    numberOfYearsOperatingInDubai: '',
    annualRevenue: '',
    productAndServices: '',
    pleaseSpecifyOthersCompanyIsInterested: '',
    areYourProductsManufacturedInDubai: '',
    doYouHaveAnyPreviousExperience: '',
    additionalInformation: '',
    descriptionOfHowYourCompanyPlansToExpand: '',
    otherBusinessSector: '',
    inquiryVersion: 0
};

const businessExpansionSlice = createSlice({
    name: 'businessExpansion',
    initialState,
    reducers: {
        setIsFormFilled(state, action: PayloadAction<boolean | null>) {
            state.isFormFilled = action.payload;
        },
        setIsChamberMember(state, action: PayloadAction<boolean | null>) {
            state.isChamberMember = action.payload;
        },
        setMemberNumber(state, action: PayloadAction<string>) {
            state.dcMembershipNumber = action.payload;
        },
        setInquiryVersion(state, action: PayloadAction<number>) {
            state.inquiryVersion = action.payload;
        },
        setFormId(state, action: PayloadAction<number>) {
            state.formId = action.payload;
        },
        setPreviousFromCountryData(state, action: PayloadAction<any>) {
            state.previousFromCountryData = action.payload;
        },
        updateFormValues(
            state,
            action: PayloadAction<Partial<BusinessExpansionState>>
        ) {
            Object.assign(state, action.payload);
        },
        resetForm() {
            return initialState;
        }
    }
});

export const {
    setIsFormFilled,
    setIsChamberMember,
    setMemberNumber,
    updateFormValues,
    resetForm,
    setFormId,
    setInquiryVersion,
    setPreviousFromCountryData
} = businessExpansionSlice.actions;

export default businessExpansionSlice.reducer;
